<template>
  <div
    style="width: 340px; margin: 0 -8px 0 2px"
    id="infoWindow"
    ref="infoWindow"
  >
    <h1 class="baidu_h1">
      <b @dblclick="utils.selectText('carNo')" id="carNo">{{
        windowData.name
      }}</b>
      <workStatus
        style="margin: 4px 4px 0 4px"
        :text="windowData.serviceStatus"
      ></workStatus>
      <car-statue
        :realTimeStatus="windowData.realTimeStatus"
        :statusDuration="windowData.statusDuration"
      ></car-statue>

      <a style="margin-left: 10px" @click="openMore = true">更多信息</a>
    </h1>
    <p>{{ address }}</p>
    <ul class="msg clearfloat">
      <Row v-if="windowData.deviceUseType == 1">
        <Col span="18">
          <Row>
            <Col span="12">
              <ly-form-item label="当前速度"
                >{{ windowData.speed }}km/h</ly-form-item
              >
            </Col>
            <Col span="12">
              <ly-form-item lw="3.5" label="里程数"
                >{{ windowData.mileage }}km</ly-form-item
              > </Col
            ><Col span="12">
              <ly-form-item label="当前油量"
                >{{ windowData.oilLiters }}L</ly-form-item
              >
            </Col>
            <Col span="12" v-show="windowData.deviceUseType == 1">
              <ly-form-item lw="3.5" label="发动机">{{
                windowData.accStatus
              }}</ly-form-item>
            </Col>

            <Col span="24">
              <ly-form-item label="GPS时间">{{
                windowData.gpsTime
              }}</ly-form-item>
            </Col>
            <Col span="24" v-show="windowData.deviceUseType == 1">
              <ly-form-item label="作业标段">{{
                windowData.serviceName
              }}</ly-form-item>
            </Col>
          </Row>
        </Col>
        <Col span="6">
          <viewer>
            <img
              id="windownDataimg"
              :title="windowData.carTypeName"
              :src="
                axios.platConfig.fileUri +
                'mapicon/' +
                windowData.icon +
                '/big.png'
              "
            />
          </viewer>
        </Col>
      </Row>
      <Row v-if="windowData.deviceUseType == 2">
        <Col span="18">
          <Row>
            <Col span="12">
              <ly-form-item label="工牌号">{{
                windowData.personJobNo
              }}</ly-form-item>
            </Col>
            <Col span="12">
              <ly-form-item lw="2.5" label="电话">{{
                windowData.personTel
              }}</ly-form-item>
            </Col>
            <Col span="12"
              ><ly-form-item lw="2.5" label="速度"
                >{{ windowData.speed }}km/h</ly-form-item
              >
            </Col>
            <Col span="12">
              <ly-form-item lw="2.5" label="里程"
                >{{ windowData.mileage }}km</ly-form-item
              >
            </Col>
            <Col span="24">
              <ly-form-item label="设备电量"
                ><elect :num="windowData.electricity"></elect>
              </ly-form-item>
            </Col>
            <span span="24">
              <ly-form-item label="GPS时间">{{
                windowData.gpsTime
              }}</ly-form-item>
            </span>
          </Row>
        </Col>
        <Col span="6">
          <viewer>
            <img
              id="windownDataimg"
              :src="
                axios.platConfig.fileUri +
                'mapicon/' +
                windowData.icon +
                '/big.png'
              "
            />
          </viewer>
        </Col>
      </Row>
    </ul>
    <ul class="caozuo" v-if="windowData.deviceUseType == 1">
      <Button type="primary" size="small" @click="sashuiche(windowData)"
        >作业情况</Button
      >
      <Button type="primary" size="small" @click="guiji()">历史轨迹</Button>
      <Button type="primary" v-if="false" size="small" @click="share()"
        >语音对讲</Button
      >
      <Button type="primary" v-if="false" size="small" @click="lookStree"
        >查看街景</Button
      >
      <Button type="primary" size="small" @click="adddd(windowData)"
        >查看视频</Button
      >
    </ul>
    <ul class="caozuo" v-if="windowData.deviceUseType == 2">
      <Button type="primary" size="small" @click="personGuiji()"
        >历史轨迹</Button
      >
    </ul>
    <Drawer
      title="更多信息"
      placement="right"
      :closable="true"
      :mask="true"
      :draggable="false"
      width="240"
      v-model="openMore"
    >
      <Row v-if="windowData.deviceUseType == 1">
        <Col span="24">
          <ly-form-item label="车辆类型">{{
            windowData.carTypeName
          }}</ly-form-item>
        </Col>

        <Col span="24">
          <ly-form-item label="司机姓名">{{
            windowData.driverName
          }}</ly-form-item>
        </Col>
        <Col span="24">
          <ly-form-item label="司机电话">{{
            windowData.driverTel
          }}</ly-form-item>
        </Col>
      </Row>

      <Row>
        <Col span="24">
          <ly-form-item label="设备类型">{{
            windowData.deviceModel
          }}</ly-form-item>
        </Col>
        <Col span="24">
          <ly-form-item label="设备号">{{ windowData.deviceNo }}</ly-form-item>
        </Col>
        <Col span="24">
          <ly-form-item label="SIM卡号">{{ windowData.simNo }}</ly-form-item>
        </Col>
        <Col span="24">
          <ly-form-item label="原始经度">{{ windowData.orgX }}</ly-form-item>
        </Col>
        <Col span="24">
          <ly-form-item label="原始纬度">{{ windowData.orgY }}</ly-form-item>
        </Col>
        <Col span="24">
          <ly-form-item label="高德经度">{{
            windowData.locateLng
          }}</ly-form-item>
        </Col>
        <Col span="24">
          <ly-form-item label="高德纬度">{{
            windowData.locateLat
          }}</ly-form-item>
        </Col>
        <Col span="24">
          <ly-form-item label="事件说明">{{
            windowData.eventDesc
          }}</ly-form-item>
        </Col>
        <Col span="24">
          <ly-form-item label="报警类型">
            {{ windowData.alarmList }}
          </ly-form-item>
        </Col>
      </Row>
    </Drawer>
    <stree ref="bmapStree"></stree>
    <sashuiche ref="sashuiche"></sashuiche>
    <share ref="share"></share>
  </div>
</template>
<script>
import sashuiche from "./sashuiche";

import workStatus from "../common/workStatus.vue";
import carStatue from "../common/carStatue.vue";
import stree from "./com/stree.vue";
import zhiling from "./com/zhiling.vue";
import share from "./share/index.vue";
import elect from "./com/elect.vue";
export default {
  props: ["windowData"],
  components: { carStatue, stree, sashuiche, share, elect, workStatus },
  data() {
    return {
      openMore: false,
      isTrack: false,
      address: "",
    };
  },
  methods: {
    //点击轨迹按钮
    guiji(s) {
      this.$store.state.carMsg.carNo = this.windowData.carNo; //车牌号给客户
      this.$store.state.carMsg.deviceNo = this.windowData.deviceNo; //车牌号给客户
      this.utils.changeTopMenu(this, { name: "行车轨迹", link: "/locus" });
      this.$router.push({ path: "/locus" });
    },
    personGuiji(s) {
      this.$store.state.personMsg.carNo = this.windowData.name; //车牌号给客户
      this.$store.state.personMsg.deviceNo = this.windowData.deviceNo; //车牌号给客户
      this.utils.changeTopMenu(this, { name: "行车轨迹", link: "/locus" });
      this.$router.push({ path: "/locusPeson" });
    },
    //点击轨迹按钮
    lookOil(s) {
      if (this.windowData.oilVolume == null) {
        this.$Message.error("未安装油针");
        return;
      }
      this.$store.state.carMsg.carNum = this.windowData.num; //车牌号给客户看的
      this.$store.state.carMsg.deviceId = this.windowData.deviceId; //上传后台的参数
      this.$store.state.carMsg.select = s; //是否立即看轨迹
      this.$store.state.carMsg.lookOilNow = true; //是否立即看轨迹
      this.$router.push({ path: "/oil/?now=1" });
    },
    //百度街景
    lookStree() {
      this.$refs.bmapStree.open(this.windowData);
    },
    //实时视频
    adddd(t) {
      console.log(this.windowData.carLabelList.includes("视频"));
      if (this.windowData.carLabelList.includes("视频")) {
        this.$emit("video", t);
      } else {
        this.$Message.warning({
          content: "车辆未贴‘视频’标签",
          duration: 2,
        });
      }
    },
    sashuiche(m) {
      this.$refs.sashuiche.open(this.windowData);
    },
    share() {
      this.$Message.info("功能待开发");
      return;
      this.$refs.share.open(this.windowData);
    },
  },
  watch: {
    windowData(m) {
      //this.isTrack=false;
      var pointList = [
        {
          x: m.orgX,
          y: m.orgY,
        },
      ];
      this.utils.jiexi(pointList).then((data) => {
        this.address = data[0].address;
      });
    },
  },
  mounted() {
    //console.log(this.windowData);
  },
};
</script>
<style lang="">
.baidu_h1 {
  font-size: 1.3em;
  color: #333;
  margin-top: 0;
  font-weight: 500;
  margin-bottom: 6px;
  margin-left: 0px;
  display: flex;
}
.baidu_h1 .carLabel {
  color: #fff;
  font-size: 10px;
  padding: 1px 4px;
  border-radius: 10px;
  position: relative;
  top: -2px;
}
.baidu_h1 span {
  font-size: 12px;
}
.red {
  color: #fc3737;
}
#address {
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
  font-size: 12px;
  margin-left: 0px;
}
.msg {
  margin-top: 10px;
  line-height: 1;
  width: 100%;
  padding: 0px 0px 4px 0px;
}
.msg label {
  color: #999;
  margin-right: 6px;
  font-size: 12px;
}
.msg span {
  color: #333;
  margin-right: 6px;
  font-size: 12px;
}
.caozuo {
  display: flex;
  margin-top: 8px;
  padding-left: 0px;
}
.caozuo button {
  margin-right: 4px;
}
#windownDataimg {
  width: 100%;
  height: 74px;
  background: #f5f5f5;
  border: solid 1px #aaa;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/locate/iconWindow.vue